import { render, staticRenderFns } from "./ColorLegend.vue?vue&type=template&id=bac6a4d4&scoped=true&"
import script from "./ColorLegend.vue?vue&type=script&lang=js&"
export * from "./ColorLegend.vue?vue&type=script&lang=js&"
import style0 from "./ColorLegend.vue?vue&type=style&index=0&id=bac6a4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac6a4d4",
  null
  
)

/* custom blocks */
import block0 from "./ColorLegend.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bac6a4d4')) {
      api.createRecord('bac6a4d4', component.options)
    } else {
      api.reload('bac6a4d4', component.options)
    }
    module.hot.accept("./ColorLegend.vue?vue&type=template&id=bac6a4d4&scoped=true&", function () {
      api.rerender('bac6a4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ColorLegend.vue"
export default component.exports